import { useMemo } from 'react';
import { TICK_SCALES } from '@/feature/order_book/constants.ts';
import { useSelectedMarketField, useSelectedMarketId } from '../../../store/rootStore.ts';

export function useOrderBookTickLevels() {
  const selectedMarketId = useSelectedMarketId();
  const quoteDecimals = useSelectedMarketField('quoteDecimals');
  const marketKey = selectedMarketId != null ? String(selectedMarketId) : undefined;

  const tickLevels = useMemo(() => {
    if (quoteDecimals == null) {
      return [];
    }
    return TICK_SCALES.map((scale) => (scale / 10 ** quoteDecimals).toString());
  }, [quoteDecimals]);

  return { marketKey, tickLevels };
}
